export default "__VITE_ASSET__Cz$Biqmh__"